import ActionBar from 'components/ui/action-bar';
import ActionBarAction from 'components/ui/action-bar/ActionBarAction';
import COLOR from 'constants/color';
import AddOutlined from 'assets/icons/revamp/add-outlined';
import { t } from 'services/i18n.service';
import { TrashOutlined } from 'assets/icons/revamp';
import { getHabitAccessibleName } from 'utils/habit-accessibility.util';

interface HabitActionBarProps {
  onAddHabit?: () => void;
  onMoreOptions?: () => void;
  onDelete?: () => void;
  onAddHover?: (isHovering: boolean) => void;
  className?: string;
  habitName?: string;
}

const HabitActionBar: React.FC<HabitActionBarProps> = ({
  onAddHabit,
  onMoreOptions,
  onDelete,
  onAddHover,
  className = '',
  habitName
}) => {
  const habitLabelParams = { habit: getHabitAccessibleName(habitName) };
  return (
    <ActionBar
      className={`flex items-end justify-between ~gap-3/5 ~-mb-3/6 ${className}`}>
      <div
        onMouseEnter={() => onAddHover?.(true)}
        onMouseLeave={() => onAddHover?.(false)}
        className='inline-flex'>
        <ActionBarAction
          icon={
            <AddOutlined
              className='~w-4/6 ~h-4/6 text-primary-700 dark:text-primary-dark-500'
              fill='currentColor'
              fillDarkMode='currentColor'
            />
          }
          variant='icon'
          onClick={onAddHabit}
          aria-label={t(
            'habit_actions_aria_labels.insert_after',
            habitLabelParams
          )}
          data-testid='add-habit'
        />
      </div>

      <div className='flex items-center ~gap-2/3'>
        {onMoreOptions ? (
          <ActionBarAction
            label={t('settings_page.more_options')}
            variant='text'
            onClick={onMoreOptions}
            aria-label={t(
              'habit_actions_aria_labels.more_options',
              habitLabelParams
            )}
            data-testid='more-options'
            className='min-w-max ~px-2/3'
            size='small'
          />
        ) : null}
        {onDelete ? (
          <ActionBarAction
            icon={
              <TrashOutlined
                className='~w-4/6 ~h-4/6'
                fill={COLOR.SEMANTIC.ERROR}
              />
            }
            variant='icon'
            onClick={onDelete}
            aria-label={t('habit_actions_aria_labels.delete', habitLabelParams)}
            data-testid='delete'
          />
        ) : null}
      </div>
    </ActionBar>
  );
};

export default HabitActionBar;
